import React from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { useParams } from "react-router-dom";
import AdminOnly from "../../../../components/AdminOnly";
import CustomeButton from "../../../../components/Button/index";
import ToastMessage from "~/components/ToastMessage";
import LocationAddressForm from "./LocationAddressForm";
import useEditEmployeeAddress from "../../actions/useEditEmployeeAddress";
import AuditSidebar from "~/components/audit-sidebar/AuditSidebar";
import API_ROUTES from "~/api-routes-v2";

const EditLocationAddress = () => {
  const { id } = useParams();
  const {
    onChangeAddress,
    statesarray,
    cityarray,
    genstate,
    handleEnableEdit,
    handleDiscardEdit,
    handleUpdateAddress,
    setAuditSidebarVisible,
    toastRef,
    reset,
    isDataAvailable,
  } = useEditEmployeeAddress();
  const auditLabels = () => ({
    update: "Location & Address Updated",
    create: `Location & Address Added`,
    delete: `Location & Address Deleted`,
  });

  return (
    <>
      <Card className="card-onboard">
        <div className="formgrid grid flex justify-content-between mb-4 align-items-center">
          <div className="">
            <p className="heading m-0 mb-2">Location & Address</p>
            <p className="description m-0">
              Key data for payroll, taxation, and legal compliance across
              regions.
            </p>
          </div>
          <AdminOnly>
            <div className="flex gap-1">
              {genstate.isEdit ? (
                <>
                  <CustomeButton
                    label="Discard"
                    variant="outlined"
                    className="mr-2"
                    onClick={handleDiscardEdit}
                  />
                  <CustomeButton
                    label={"Save Changes"}
                    variant="contained"
                    onClick={handleUpdateAddress}
                    loading={genstate?.isUpdating}
                    disabled={genstate?.isUpdating || genstate?.isSaveBtn}
                    className={`mr-2 access-btn  ${genstate?.isSaveBtn && "disable"}`}
                    iconPos="right"
                  />
                </>
              ) : (
                <>
                  <Button
                    className="edit-button"
                    onClick={() => setAuditSidebarVisible(true)}
                  >
                    View History
                    <span className="pi pi-history mb-1 ml-2" />
                  </Button>
                  <CustomeButton
                    label="Edit"
                    variant="contained"
                    className="mr-2 access-btn"
                    onClick={handleEnableEdit}
                    icon="pi pi-pencil"
                    iconPos="right"
                  />
                </>
              )}
            </div>
          </AdminOnly>
        </div>
        <div className="formgrid grid">
          <LocationAddressForm
            handleChange={onChangeAddress}
            data={{
              ...genstate?.geninfo,
              cityLoader: genstate?.isCityLoading,
              stateLoader: genstate?.isStateLoading,
            }}
            states={statesarray}
            cities={cityarray}
            isEdit={genstate?.isEdit}
            resetForm={reset}
            isLoading={!isDataAvailable}
          />
        </div>
        {genstate.isAuditSidebarVisible && (
          <AuditSidebar
            heading="Location and Address"
            endpoint={API_ROUTES.FETCH_EMPLOYEE_AUDIT}
            id={id}
            objectType="LOCATION_ADDRESS"
            labels={auditLabels}
            setSidebarToggle={setAuditSidebarVisible}
            sidebarToggle={genstate.isAuditSidebarVisible}
          />
        )}
        <ToastMessage ref={toastRef} />
      </Card>
    </>
  );
};

export default EditLocationAddress;
